exports.ROLES={
    SYSTEMADMIN:"systemadmin",
    ADMIN :"admin",
    EDITOR :"editor",
}

exports.POST_STATUS ={
     DRAFT:"draft",
     PUBLISHED:"published"
    }


exports.POST_CATEGORIES ={
    Public_Announcement:"Public Announcement",
    Tender_Notice:"Tender Notice",
    Short_Level_Falls: "Short Level Falls",
    Map_Meter_Refund: "Map-Meter-Refund",
    Publications: "Publications",
    Lastest_Update: "Lastest-Update",
}